import { apiClient } from './client';

export interface ChildExportPayload {
  child: {
    id: string;
    first_name: string;
    last_name: string;
    date_of_birth: string | null;
    gender: string | null;
    created_date: string;
  };
  observations: Array<Record<string, unknown>>;
  assessments: Array<Record<string, unknown>>;
  consents: Array<Record<string, unknown>>;
  export_metadata: {
    exported_by: string;
    export_reason: string;
  };
}

export const dataExportApi = {
  async exportChild(childId: string): Promise<ChildExportPayload> {
    const response = await apiClient.get<ChildExportPayload>(`/data-export/child/${childId}`);
    return response.data;
  },
};
